import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        onClose: '&',
        onUpdate: '&',
        departments: '=',
        roles: '=',
        levels: '=',
        user: '=',
        drlId: '=',
        userDrlCourses: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.onClose()"></button>
            <h2 ng-if="!vm.drlId">{{ 'user.Add position' | translate }}</h2>
            <h2 ng-if="vm.drlId">{{ 'user.Edit position' | translate }}</h2>
        </div>
        <div class="modal-body">
            <form-wrapper form="vm.form">
                <div class="form">
                    <form-row ng-if="vm.form.errors.drls[0].drls" error="vm.form.errors.drls[0].drls">
                        <div class="items"><form-row-error></form-row-error></div>
                    </form-row>
                    <form-row error="vm.form.errors.drls[0].departmentId">
                        <label class="label">{{ 'user.Department' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <ui-select ng-model="vm.department" theme="selectize" title="{{ 'user.Choose department' | translate }}">
                                <ui-select-match placeholder="{{ 'user.Select or search a department in the list...' | translate }}">{{$select.selected.name}}</ui-select-match>
                                <ui-select-choices repeat="department in vm.departments | filter: $select.search">
                                    <span ng-bind-html="department.name | highlight: $select.search" class="{{department.class}}"></span>
                                </ui-select-choices>
                            </ui-select>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.drls[0].roleId">
                        <label class="label">{{ 'user.Role' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <ui-select ng-model="vm.role" theme="selectize" title="{{ 'user.Choose role' | translate }}">
                                <ui-select-match placeholder="{{ 'user.Select or search a role in the list...' | translate }}">{{$select.selected.name}}</ui-select-match>
                                <ui-select-choices repeat="role in vm.roles | filter: $select.search">
                                    <span ng-bind-html="role.name | highlight: $select.search" class="{{role.class}}"></span>
                                </ui-select-choices>
                            </ui-select>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.drls[0].levelId">
                        <label class="label">{{ 'user.Level' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <ui-select ng-model="vm.level" theme="selectize" title="{{ 'user.Choose level' | translate }}">
                                <ui-select-match placeholder="{{ 'user.Select or search a level in the list...' | translate }}">{{$select.selected.name}}</ui-select-match>
                                <ui-select-choices repeat="level in vm.levels | filter: $select.search">
                                    <span ng-bind-html="level.name | highlight: $select.search" class="{{level.class}}"></span>
                                </ui-select-choices>
                            </ui-select>
                        </div>
                    </form-row>
                    <!-- <div class="row todo">
                        <label class="label">From</label>
                        <div class="items">
                            <datepicker ng-model="dateStart"></datepicker>
                        </div>
                    </div>
                    <div class="row todo">
                        <label class="label">To</label>
                        <div class="items">
                            <datepicker ng-model="dateStart"></datepicker>
                        </div>
                    </div> -->
                </div>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary" ng-if="!vm.form.saving">
                    <button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button>
                </li>
                <li ng-if="!vm.isSingleDrl && vm.drlId && !vm.form.saving" class="primary">
                    <button class="btn negative" type="button" ng-click="vm.delete()">{{ 'general.Delete' | translate }}</button>
                </li>
                <li ng-if="vm.isSingleDrl && vm.drlId" class="primary">
                    <div tooltip-append-to-body="true" uib-tooltip="{{ vm.deletePlaceHolder }}" class="btn negative disabled"
                    >{{ 'general.Delete' | translate }}</div>
                </li>
                <li><button class="btn discrete" type="button" ng-click="vm.onClose()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, $q, toastr, lodash, ModalService, FormFactory, UserResource, CourseResource,
                 USER_STATUS_ENUM, AUTOMATED_PLANNING_GROUP_STATUS_ENUM, AUTOMATED_PLANNING_GROUP_TYPE_ENUM,
                 AUTOMATED_PLANNING_GROUP_TARGET_TYPE_ENUM, COURSE_TARGET_NEED_TYPE_ENUM) {
        this.$translate = $translate;
        this.$q = $q;
        this.toastr = toastr;
        this.lodash = lodash;
        this.ModalService = ModalService;
        this.FormFactory = FormFactory;
        this.UserResource = UserResource;
        this.CourseResource = CourseResource;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM = AUTOMATED_PLANNING_GROUP_STATUS_ENUM;
        this.AUTOMATED_PLANNING_GROUP_TYPE_ENUM = AUTOMATED_PLANNING_GROUP_TYPE_ENUM;
        this.AUTOMATED_PLANNING_GROUP_TARGET_TYPE_ENUM = AUTOMATED_PLANNING_GROUP_TARGET_TYPE_ENUM;
        this.COURSE_TARGET_NEED_TYPE_ENUM = COURSE_TARGET_NEED_TYPE_ENUM;
    }

    $onInit () {
        this.departments = this.mapClassifier(this.departments);
        this.roles = this.mapClassifier(this.roles);
        this.levels = this.mapClassifier(this.levels);
        this.deletePlaceHolder = this.$translate.instant('user.At least 1 position must exist for the employee');

        this.initDrl();
        this.createForm();

        this.isSingleDrl = this.form.model.drlsWithValue.length === 1;

        this.detectApgCourseTargets();
    }

    /**
     * userDrlCourses are courses that have connection with APG and matched through userDrls
     * Collect all course related targets (automatic with ALL_COURSE_TARGETS will add all course targets, custom targets will be collected separately).
     * Result will be unique course based targets that user has match with
     */
    detectApgCourseTargets () {
        const matchedCourseTargets = [];

        if (this.user.status === this.USER_STATUS_ENUM.KEYS.INACTIVE) {
            return;
        }

        if (!this.drlId) {
            return;
        }

        this.userDrlCourses.forEach((course) => {
            course.planningGroups.forEach((apg) => {
                if (apg.status === this.AUTOMATED_PLANNING_GROUP_STATUS_ENUM.KEYS.CANCELLED
                || apg.type !== this.AUTOMATED_PLANNING_GROUP_TYPE_ENUM.KEYS.AUTOMATIC) {
                    return; // go to next iteration
                }

                if (apg.targetType === this.AUTOMATED_PLANNING_GROUP_TARGET_TYPE_ENUM.KEYS.ALL_COURSE_TARGETS) {
                    course.courseTargets.forEach((courseTarget) => {
                        if (courseTarget.type !== this.COURSE_TARGET_NEED_TYPE_ENUM.KEYS.COMPULSORY) {
                            return;
                        }
                        matchedCourseTargets.push(courseTarget);
                    });
                }

                apg.planningGroupTargets.forEach((apgTarget) => {
                    const target = this.lodash.find(course.courseTargets, (courseTarget) => parseInt(courseTarget.id, 10) === parseInt(apgTarget.courseTargetId, 10));
                    if (target) {
                        matchedCourseTargets.push(target);
                    }
                });
            });
        });

        this.groupByCourse(matchedCourseTargets);
    }

    groupByCourse (matchedCourseTargets) {
        this.groupedCourseTargetsInApg = matchedCourseTargets.reduce((original, target) => {
            if (!original[target.courseId]) {
                original[target.courseId] = [];
            }
            if (original[target.courseId].some((courseTarget) => courseTarget.id === target.id)) {
                return original;
            }

            original[target.courseId].push(target);
            return original;
        }, {});
    }

    mapClassifier (classifier) {
        return classifier.map((val) => ({ name: val.value, id: val.id }));
    }

    initDrl () {
        this.department = { id: undefined, name: undefined };
        this.role = { id: undefined, name: undefined };
        this.level = { id: undefined, name: undefined };

        if (this.drlId) {
            // find correct object from array to display on form
            this.drlBeforeUpdate = this.lodash.find(this.user.drlsWithValue, { id: this.drlId });

            this.department = { id: this.drlBeforeUpdate.departmentId, name: this.drlBeforeUpdate.departmentName };
            this.role = { id: this.drlBeforeUpdate.roleId, name: this.drlBeforeUpdate.roleName };
            this.level = { id: this.drlBeforeUpdate.levelId, name: this.drlBeforeUpdate.levelName };
        }
    }

    createForm () {
        this.form = this.FormFactory.create(this.user, model => model.$update({ id: model.id }));
    }

    beforeSave () {
        this.form.model.drls = this.lodash.filter(this.form.model.drlsWithValue, drl => drl.id !== this.drlId);
        this.form.model.drls.unshift({
            id: this.drlId,
            departmentId: this.department.id,
            roleId: this.role.id,
            levelId: this.level.id
        });
    }

    beforeDelete () {
        this.form.model.drls = this.lodash.filter(this.form.model.drlsWithValue, drl => drl.id !== this.drlId);
    }

    confirm (message) {
        const drlChanged = this.drlBeforeUpdate.departmentId !== this.department.id
            || this.drlBeforeUpdate.roleId !== this.role.id
            || this.drlBeforeUpdate.levelId !== this.level.id;

        const deferred = this.$q.defer();

        if (!drlChanged) {
            deferred.resolve();
            return deferred.promise;
        }

        if (this.lodash.isEmpty(this.groupedCourseTargetsInApg)) {
            deferred.resolve();
            return deferred.promise;
        }

        this.hasMismatch = false;

        // detect if all user drls are presented in groupedCourseTargetsInApg
        // each course is handled separately (we need match within every connected course)
        let hasTargetMatch;
        this.lodash.forOwn(this.groupedCourseTargetsInApg, (targets) => {
            // reset before each course targets iteration
            hasTargetMatch = false;
            // if we have at least one match for all user drl in comparison with compulsory APG connected course targets
            targets.forEach((target) => {
                const hasDepartmentMatch = !target.departmentId || this.form.model.drls.find((drl) => parseInt(drl.departmentId, 10) === parseInt(target.departmentId, 10));
                const hasRoleMatch = !target.roleId || this.form.model.drls.find((drl) => parseInt(drl.roleId, 10) === parseInt(target.roleId, 10));
                const hasLevelMatch = !target.levelId || this.form.model.drls.find((drl) => parseInt(drl.levelId, 10) === parseInt(target.levelId, 10));

                const hasMatch = hasDepartmentMatch && hasRoleMatch && hasLevelMatch;
                // we need to force true value here if it was once true
                if (!hasTargetMatch) {
                    hasTargetMatch = hasMatch;
                }
            });

            if (!hasTargetMatch) {
                this.hasMismatch = true;
            }
        });

        if (this.hasMismatch) {
            this.ModalService.confirm(message)
                .then(() => deferred.resolve())
                .catch(() => deferred.reject())
            ;
        }
        else {
            deferred.resolve();
        }

        return deferred.promise;
    }

    save () {
        this.beforeSave();
        if (this.drlId) {
            const message = this.$translate.instant('user.confirm_planning_group_user_drl_update');
            this.confirm(message).then(() => this.doSave());
        }
        else {
            this.doSave();
        }
    }

    delete () {
        return this.ModalService.delete(this.$translate.instant('user.You are about to remove the position from the employee.'))
            .then(() => {
                this.beforeDelete();
                this.doSave().then(() => this.toastr.success(this.$translate.instant('user.Position deleted')));
            });
    }

    doSave () {
        return this.form.save().then(() => this.onUpdate());
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/user/employee/drl/index.js